import SuperTokensSession from 'supertokens-web-js/recipe/session'
import { appInfo } from '../config/appinfo'

const fetchWithCredentials = async (url: string, options: RequestInit = {}) => {
  
  const accessToken = await SuperTokensSession.getAccessToken()

  const response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.statusText}`)
  }
  return response.json()
}

export const authAPI = {
  getCurrentUser: () =>
    fetchWithCredentials(`${appInfo.apiDomain}/api/auth/me`),
}